import * as React from 'react';
import { IFormField } from '../../../../interfaces/interfaces';

export default (props: IFormField) => {
    const { fieldName, type, onChange, value, label, errorMessage, isRequired, placeholder } = props;
    const inputId = 'input' + fieldName;

    return (
        <div key={fieldName} className={'form__item' + (errorMessage ? ' hasError' : '')} style={{ width: '100%' }}>
            <label htmlFor={inputId} className="label">
                {label}
            </label>
            <textarea
                style={{ width: '100%' }}
                id={inputId}
                className="textarea"
                name={fieldName}
                onChange={onChange}
                data-value={value || ''}
                required={isRequired}
            />
            {errorMessage && <p className={'form__error'}>{errorMessage}</p>}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/TextArea.tsx